// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  position: relative;
  margin: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  border-radius: 6px;
  padding: 1rem;
  overflow: hidden;
  background: white;
  /* width: 50%; */
  /* max-width: 100rem; */
}

.instrument-list-header {
  margin: 10px 10px 4px 10px !important;
  padding: 1rem;
  background: #eaeaea;
}

.trade-list-header {
  margin: 4px 10px 4px 10px !important;
  padding: 1rem;
  background: #eaeaea; 
}

.instrument-item {
  margin: 4px 10px 4px 10px;
  padding: 16px;
}

.instrument-item table,
.instrument-list-header table,
.trade-list-header table {
  width: 100%;
  text-align: center;
  border-collapse: separate;
  table-layout: fixed;
  text-align: center;
  color: black;
  border-radius: 5px; /* Curved edges */
}

/* .instrument-item tbody tr:hover { */
  /* background-color: #eaeaea;  Changes background on row hover */
/* } */

/* Center text in all table cells */
.instrument-item th td,
.instrument-list-header th td,
.trade-list-header th td {
  cursor: pointer;
  text-align: center;
  border-radius: 5px; /* Curved edges */
  padding: 8px;  /* Adds space inside cells */
  transition: background-color 0.3s;
}

.instrument-item:hover {
  background-color: #eaeaea;  /* Changes background on row hover */
}

/* Active column background */
.instrument-list-header th.active {
  border: 2px solid #000000;
  border-radius: 5px; /* Curved edges */
  padding: 8px;
  background-color: #d0d0d0; /* Adjust color as needed */
}

/* Hover effect */
.instrument-list-header th:hover {
  background-color: #d0d0d0; /* Adjust color as needed */
  border: 2px solid #000000;
  padding: 8px;
  border-radius: 5px; /* Curved edges */
}`, "",{"version":3,"sources":["webpack://./src/shared/components/UIElements/Card.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAE,iBAAiB;AACvC;;AAEA,sCAAsC;EACpC,gEAAgE;AAClE,MAAM;;AAEN,mCAAmC;AACnC;;;EAGE,eAAe;EACf,kBAAkB;EAClB,kBAAkB,EAAE,iBAAiB;EACrC,YAAY,GAAG,4BAA4B;EAC3C,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,GAAG,oCAAoC;AAClE;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB,EAAE,iBAAiB;EACrC,YAAY;EACZ,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,2BAA2B;EACtD,yBAAyB;EACzB,YAAY;EACZ,kBAAkB,EAAE,iBAAiB;AACvC","sourcesContent":[".card {\n  position: relative;\n  margin: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n  border-radius: 6px;\n  padding: 1rem;\n  overflow: hidden;\n  background: white;\n  /* width: 50%; */\n  /* max-width: 100rem; */\n}\n\n.instrument-list-header {\n  margin: 10px 10px 4px 10px !important;\n  padding: 1rem;\n  background: #eaeaea;\n}\n\n.trade-list-header {\n  margin: 4px 10px 4px 10px !important;\n  padding: 1rem;\n  background: #eaeaea; \n}\n\n.instrument-item {\n  margin: 4px 10px 4px 10px;\n  padding: 16px;\n}\n\n.instrument-item table,\n.instrument-list-header table,\n.trade-list-header table {\n  width: 100%;\n  text-align: center;\n  border-collapse: separate;\n  table-layout: fixed;\n  text-align: center;\n  color: black;\n  border-radius: 5px; /* Curved edges */\n}\n\n/* .instrument-item tbody tr:hover { */\n  /* background-color: #eaeaea;  Changes background on row hover */\n/* } */\n\n/* Center text in all table cells */\n.instrument-item th td,\n.instrument-list-header th td,\n.trade-list-header th td {\n  cursor: pointer;\n  text-align: center;\n  border-radius: 5px; /* Curved edges */\n  padding: 8px;  /* Adds space inside cells */\n  transition: background-color 0.3s;\n}\n\n.instrument-item:hover {\n  background-color: #eaeaea;  /* Changes background on row hover */\n}\n\n/* Active column background */\n.instrument-list-header th.active {\n  border: 2px solid #000000;\n  border-radius: 5px; /* Curved edges */\n  padding: 8px;\n  background-color: #d0d0d0; /* Adjust color as needed */\n}\n\n/* Hover effect */\n.instrument-list-header th:hover {\n  background-color: #d0d0d0; /* Adjust color as needed */\n  border: 2px solid #000000;\n  padding: 8px;\n  border-radius: 5px; /* Curved edges */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
